import { InviteMemberError, type InviteMemberErrorReason } from "@ext/enterprise-cloud/GesCloudApi";
import t from "@ext/localization/locale/translate";

export interface InviteErrorAlert {
	status: "info" | "error";
	icon: string;
	message: string;
}

const getInviteErrorMessage = (reason: InviteMemberErrorReason | undefined): string => {
	switch (reason) {
		case "SubscriptionRequired":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.subscription-required");
		case "SubscriptionPastDue":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.subscription-past-due");
		case "SubscriptionSuspended":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.subscription-suspended");
		case "SeatPurchaseRequired":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.seat-purchase-required");
		case "InvalidRole":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.invalid-role");
		case "AdminRequiresEditorRole":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.admin-requires-editor-role");
		case "AdminRequiresOwner":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.admin-requires-owner");
		case "EditorRoleRequiresWorkspaceEditor":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.editor-role-requires-workspace-editor");
		case "AlreadyInvited":
			return t("enterprise-cloud.org-settings.users.invite-form.errors.already-invited");
		default:
			return t("enterprise-cloud.org-settings.users.invite-form.errors.generic");
	}
};

export const getInviteErrorAlert = (error: unknown): InviteErrorAlert => {
	const reason = error instanceof InviteMemberError ? error.reason : undefined;
	const message = getInviteErrorMessage(reason);
	const isSeatLimit = reason === "SubscriptionRequired" || reason === "SeatPurchaseRequired";
	return isSeatLimit ? { status: "info", icon: "info", message } : { status: "error", icon: "alert-circle", message };
};
